import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

function HandleUserLinkPage() {
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleUserLink = async () => {
      try {
        await fetch(`https://render-suq-backend.onrender.com/${username}`, { method: 'POST' }); // Call the POST endpoint
        navigate('/categories'); // Redirect to /categories
      } catch (error) {
        console.error('Error handling user link:', error);
      }
    };

    if (username) {
      handleUserLink();
    }
  }, [username, navigate]);

  return (
    <SEO
      title="Processing invite... | Holy Wear House"
      description="Redirecting you to the latest Christian clothing collections on Holy Wear House."
      path={`/${username || ''}`}
      noIndex
    />
  ); // Render only metadata since this route redirects immediately
}

export default HandleUserLinkPage;
